import { formValueSelector, initialize } from 'redux-form';
import gettext from '@eb/gettext';
import { moment } from '@eb/date';

import {
    DATE_MONTH_DAY_FORMAT,
    DATE_TIME_FORMAT,
    SALES_STATUS_ON_SALE_OPTION,
    SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED_OPTION,
    SALES_STATUS_SALES_ENDED_OPTION,
    FORM_NAME,
    LOCALIZED_TEXT,
    SALES_STATUS_DEFAULT_OPTIONS,
    FIELD_NAMES,
    DISPLAY_SALES_STATUS_TO_WARNING_NOTIFICATION_TEXT_MAP,
} from './constants';
import { event, constants } from '@eb/event-create-publish-utils';

const {
    utils: {
        getStatusCode,
        isStatusCustom,
        isStatusOnSale,
        isStatusNotYetOnSale,
        isStatusNotYetOnSaleAccessCoded,
        isStatusSalesEnded,
    },
    actions: { loadingEventSalesStatusModal, loadEventSalesStatusComplete },
} = event;

const {
    DISPLAY_SALES_STATUS_CUSTOM,
    DISPLAY_SALES_STATUS_NOT_YET_ON_SALE,
} = constants;

const getCustomOption = (isOnSale) => {
    let customOptionLabel = LOCALIZED_TEXT.customOptionLabelScheduled;

    if (isOnSale) {
        customOptionLabel = LOCALIZED_TEXT.customOptionLabelOnSale;
    }

    return {
        display: customOptionLabel,
        value: DISPLAY_SALES_STATUS_CUSTOM,
    };
};

const fieldValueSelector = formValueSelector(FORM_NAME);

export const getFieldValue = (state, field) => fieldValueSelector(state, field);

export const getNotYetOnSaleStatusOption = ({
    local: ticketStartDate = '',
}) => {
    const stringFormat = {
        dateMonthDayFormat: DATE_MONTH_DAY_FORMAT,
        dateTimeFormat: DATE_TIME_FORMAT,
    };
    const isNotYetOnSaleOptionText = gettext(
        '[On Sale] %(dateMonthDayFormat)s [at] %(dateTimeFormat)s',
        stringFormat,
    );
    const isNotYetOnSaleOption = {
        display: moment(ticketStartDate).format(isNotYetOnSaleOptionText),
        value: DISPLAY_SALES_STATUS_NOT_YET_ON_SALE,
    };

    return isNotYetOnSaleOption;
};

export const getStatusOptions = (eventSalesStatus) => {
    const {
        customEventStatusEnabled,
        isOnSale,
        salesStartDate,
    } = eventSalesStatus;
    let statusOptions = [...SALES_STATUS_DEFAULT_OPTIONS];

    if (customEventStatusEnabled) {
        statusOptions = [...statusOptions, getCustomOption(isOnSale)];
    }

    if (isStatusOnSale(eventSalesStatus)) {
        statusOptions = [SALES_STATUS_ON_SALE_OPTION, ...statusOptions];
    } else if (
        isStatusNotYetOnSale(eventSalesStatus) &&
        !isStatusCustom(eventSalesStatus)
    ) {
        statusOptions = [
            getNotYetOnSaleStatusOption(salesStartDate),
            ...statusOptions,
        ];
    } else if (
        isStatusNotYetOnSaleAccessCoded(eventSalesStatus) &&
        !isStatusCustom(eventSalesStatus)
    ) {
        statusOptions = [
            SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED_OPTION,
            ...statusOptions,
        ];
    } else if (isStatusSalesEnded(eventSalesStatus)) {
        statusOptions = [SALES_STATUS_SALES_ENDED_OPTION, ...statusOptions];
    }

    return statusOptions;
};

export const initializeSalesStatusForm = () => (dispatch, getState) => {
    const { eventSalesStatus = {} } = getState();

    dispatch(loadingEventSalesStatusModal());

    dispatch(
        initialize(FORM_NAME, {
            statusCode: getStatusCode(eventSalesStatus),
            customMessage: eventSalesStatus.salesStatusMessage,
        }),
    );
    dispatch(loadEventSalesStatusComplete());
};

export const hasSalesStatusFormChanged = (selectedStatusCode, state) => {
    const { eventSalesStatus = {} } = state;

    if (isStatusCustom(eventSalesStatus)) {
        const currentFormCustomMessage = getFieldValue(
            state,
            FIELD_NAMES.customMessage,
        );

        return currentFormCustomMessage !== eventSalesStatus.salesStatusMessage;
    } else if (
        isStatusOnSale(eventSalesStatus) ||
        isStatusNotYetOnSale(eventSalesStatus) ||
        isStatusSalesEnded(eventSalesStatus)
    ) {
        return selectedStatusCode !== eventSalesStatus.salesStatusCode;
    }
    return selectedStatusCode !== eventSalesStatus.salesStatusMessageCode;
};

export const getOnSaleWarningNotificationTextForStatus = (selectedStatusCode) =>
    DISPLAY_SALES_STATUS_TO_WARNING_NOTIFICATION_TEXT_MAP[selectedStatusCode] ||
    LOCALIZED_TEXT.warningNotificationTextOnSale;
